var React = require('react');

function RemoveRoundedIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.34 3.66c-4.879-4.88-12.801-4.88-17.68 0-4.88 4.879-4.88 12.801 0 17.68 4.879 4.88 12.801 4.88 17.68 0 4.88-4.879 4.88-12.83 0-17.68zm-3.162 9.548a1.05 1.05 0 01-.723.3H7.576a1.015 1.015 0 01-1.023-1.023c0-.572.452-1.023 1.023-1.023H17.455c.572 0 1.024.451 1.024 1.023-.03.27-.121.543-.301.723z","fill":"#269C74","fillRule":"evenodd"}));
}

RemoveRoundedIconInline.defaultProps = {"width":"25","height":"25"};

module.exports = RemoveRoundedIconInline;

RemoveRoundedIconInline.default = RemoveRoundedIconInline;
